import {
  GetProcessedImagesQuery,
  ProcessedThermalImagesZipped,
} from "../types/getProcessedThermalImages";
import { JsonResponseType } from "~/types/jsonResponseType";
import { GRAPHQL_URL_STEEL_OPERATIONAL } from "~/constants/url";
import { BaseGraphQL } from "~/services/baseGraphQL";

const steelOperationalGraph = BaseGraphQL({
  baseUrl: GRAPHQL_URL_STEEL_OPERATIONAL,
});

export const getProcessedThermalImages = async (
  input: GetProcessedImagesQuery,
) => {
  const query = `
    query($input: GetProcessedThermalImagesQueryType) {
      getProcessedThermalImages(
        getProcessedThermalImagesQueryRequestVM: $input
      ) {
        messageCode
        succeed
        data {
          id
          campaignHeatId
          selectedImagesZipped
          startTimeUtc
          setId
          computerNumber
          frameCount
          thermalCalibrations {
            computer
            frameLocation
            message
            factor
          }
          concerningTemps {
            x
            y
            temp
            frameLocation
          }
        }
      }
    }
  `;

  return await steelOperationalGraph<
    ProcessedThermalImagesZipped,
    {
      getProcessedThermalImages: JsonResponseType<ProcessedThermalImagesZipped>;
    }
  >(
    {
      action: "steeloperationaldatagraphql",
      query,
      variables: {
        input,
      },
    },
    (input) => input.getProcessedThermalImages,
  );
};
